var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenMediaWorkManagementIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 21.5829H30.5C31.1833 21.5829 31.75 21.0163 31.75 20.3329C31.75 19.6496 31.1833 19.0829 30.5 19.0829H18.8333C18.15 19.0829 17.5833 19.6496 17.5833 20.3329C17.5833 21.0163 18.15 21.5829 18.8333 21.5829Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 28.2496H26.1333C26.8167 28.2496 27.3833 27.6829 27.3833 26.9996C27.3833 26.3163 26.8167 25.7496 26.1333 25.7496H18.8333C18.15 25.7496 17.5833 26.3163 17.5833 26.9996C17.5833 27.6829 18.15 28.2496 18.8333 28.2496Z",
    fill: "#5D9FE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3478 5.54043C32.8927 2.08301 30.2898 2.08301 28.8333 2.08301H22.1667C20.7082 2.08301 18.1002 2.08301 17.6503 5.55462C11.6959 6.20038 9.25 9.49889 9.25 16.6664V26.6664C9.25 33.6164 11.1333 37.9164 20.5 37.9164H30.5C39.8667 37.9164 41.75 33.6164 41.75 26.6498V16.6498C41.75 9.4972 39.3036 6.19965 33.3478 5.54043ZM28.8333 11.2497H22.1667C20.7475 11.2497 18.2401 11.2497 17.6914 8.05144C13.7557 8.51307 11.75 10.259 11.75 16.6664V26.6664C11.75 32.8331 12.9667 35.4164 20.5 35.4164H30.5C38.0333 35.4164 39.25 32.8331 39.25 26.6664V16.6664C39.25 10.279 37.2568 8.52398 33.3453 8.05578C33.1309 9.57029 32.2721 11.2497 28.8333 11.2497ZM30.9167 6.75424C30.916 8.3318 30.8792 8.74967 28.8333 8.74967H22.1667C20.5434 8.74967 20.0977 8.74967 20.0837 6.76598C20.0853 6.72777 20.0852 6.68907 20.0833 6.64995C20.0856 4.58301 20.521 4.58301 22.1667 4.58301H28.8333C30.4747 4.58301 30.9121 4.58301 30.9166 6.63383C30.9147 6.67429 30.9147 6.71446 30.9167 6.75424Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMediaWorkManagementIcon);
export default __webpack_public_path__ + "static/media/OpenMediaWorkManagementIcon.2ed1dc4d927f0d099c58f7169bc82550.svg";
export { ForwardRef as ReactComponent };